import React from 'react';
import { usePlansItems as usePlansItemsDI } from '@atlassian/jira-plans-item-store/src/index.tsx';
import { LoadStatus as LoadStatusCommonDI } from '../../../../common/ui/load-status/main.tsx';
import type { LoadStatusProps } from './types.tsx';

export const LoadStatus = ({
	LoadStatusCommon = LoadStatusCommonDI,
	usePlansItems = usePlansItemsDI,
	shouldThrowError = false,
}: LoadStatusProps) => (
	<LoadStatusCommon shouldThrowError={shouldThrowError} useProvider={usePlansItems} />
);
